import { Skeleton } from "@/app/components/shadcn/skeleton";

const SpecialProductsSkeleton = () => {
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between mb-2">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-4 w-24" />
      </div>
      <div className="flex gap-2 sm:gap-3 overflow-hidden">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="flex gap-2 sm:gap-3 p-1.5 sm:p-2 border rounded-lg min-w-50"
          >
            <Skeleton className="w-12 h-16 sm:w-16 sm:h-20 md:w-20 md:h-24 rounded-lg shrink-0" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-3/4" />
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-5 w-12" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecialProductsSkeleton;